import { Grid,  } from '@mui/material'
import styled from '@emotion/styled'

// arrow
import bigArrow from '../../assets/02_construction/06箭頭5.png'

// image
import diagramLeft from '../../assets/02_construction/00方案架構-1.png'
import diagramRight from '../../assets/02_construction/00方案架構-2.png'
import  useRWD  from '../../utils/useRWD'


export default function ConstructionBlock() {
  const { isPC, isToplet, isPhone } = useRWD()

  const StyledImg = styled.img`
  width: 100%;
  margin: ${isPhone ? '3em auto' : 'auto'};
  transform: ${isPhone ? 'scale(1.2)' : 'scale(0.8)'};
  transform-origin: center;
`

  return (
    <>
      {isPC ? (
        <Grid container alignItems="center">
          <Grid item xs={6}>
            <StyledImg src={diagramLeft} alt="" />
          </Grid>
          <Grid item xs={1}>
            <StyledImg src={bigArrow} alt="" />
          </Grid>
          <Grid item xs={5}>
            <StyledImg src={diagramRight} alt="" />
          </Grid>
        </Grid>
      ) : (
        <Grid container alignItems="center">
          <Grid item xs={12} >
            <StyledImg src={diagramLeft} alt="" />
          </Grid>
          <Grid item xs={12} >
            <img src={bigArrow} style={{width: '10%', transform: 'rotate(90deg)'}} alt="" />
          </Grid>
          <Grid item xs={12}  >
            <StyledImg src={diagramRight} alt="" />
          </Grid>
        </Grid>
      )}
    </>
  )
}

